import { render, staticRenderFns } from "./saas-footer.vue?vue&type=template&id=5e1991ea&scoped=true"
import script from "./saas-footer.vue?vue&type=script&lang=js"
export * from "./saas-footer.vue?vue&type=script&lang=js"
import style0 from "./saas-footer.vue?vue&type=style&index=0&id=5e1991ea&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1991ea",
  null
  
)

export default component.exports